const UserStatus = {
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    ARCHIVE: "ARCHIVE",
  };

  export default UserStatus;